var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiMiAlgorithmSvgrepoCom1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9454 6.79298C14.1508 6.79298 15.1279 5.81584 15.1279 4.61048C15.1279 3.40512 14.1508 2.42798 12.9454 2.42798C11.7401 2.42798 10.7629 3.40512 10.7629 4.61048C10.7629 5.81584 11.7401 6.79298 12.9454 6.79298Z",
    stroke: "#5D2EDE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1117 14.3567C21.3171 14.3567 22.2942 13.3796 22.2942 12.1742C22.2942 10.9688 21.3171 9.9917 20.1117 9.9917C18.9063 9.9917 17.9292 10.9688 17.9292 12.1742C17.9292 13.3796 18.9063 14.3567 20.1117 14.3567Z",
    stroke: "#5D2EDE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9454 21.4705C14.1508 21.4705 15.1279 20.4933 15.1279 19.288C15.1279 18.0826 14.1508 17.1055 12.9454 17.1055C11.7401 17.1055 10.7629 18.0826 10.7629 19.288C10.7629 20.4933 11.7401 21.4705 12.9454 21.4705Z",
    stroke: "#5D2EDE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68543 18.2681C6.89079 18.2681 7.86793 17.2909 7.86793 16.0856C7.86793 14.8802 6.89079 13.9031 5.68543 13.9031C4.48007 13.9031 3.50293 14.8802 3.50293 16.0856C3.50293 17.2909 4.48007 18.2681 5.68543 18.2681Z",
    stroke: "#5D2EDE"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.68543 9.73292C6.89079 9.73292 7.86793 8.75578 7.86793 7.55042C7.86793 6.34506 6.89079 5.36792 5.68543 5.36792C4.48007 5.36792 3.50293 6.34506 3.50293 7.55042C3.50293 8.75578 4.48007 9.73292 5.68543 9.73292Z",
    stroke: "#5D2EDE"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9417 13.0631C13.9151 13.0631 14.7042 12.274 14.7042 11.3006C14.7042 10.3272 13.9151 9.53809 12.9417 9.53809C11.9683 9.53809 11.1792 10.3272 11.1792 11.3006C11.1792 12.274 11.9683 13.0631 12.9417 13.0631Z",
    stroke: "#5D2EDE"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.56421 6.4366L10.838 5.17285",
    stroke: "#5D2EDE"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M14.4755 6.17041L18.5555 10.6442",
    stroke: "#5D2EDE"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7767 13.8992L14.5017 17.7579",
    stroke: "#5D2EDE"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8855 9.37305L11.5917 17.578",
    stroke: "#5D2EDE"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M7.6167 17.1018L10.7629 18.5606",
    stroke: "#5D2EDE"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M6.50293 14.0606L11.7642 6.44434",
    stroke: "#5D2EDE"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M7.69543 8.40552L11.3779 10.4868",
    stroke: "#5D2EDE"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.708 11.4993L17.9293 11.743",
    stroke: "#5D2EDE"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9418 13.0667L12.9455 17.1017",
    stroke: "#5D2EDE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiMiAlgorithmSvgrepoCom1);
export default __webpack_public_path__ + "static/media/ai-mi-algorithm-svgrepo-com 1.af40cdd5d7d5936d36fc376703443892.svg";
export { ForwardRef as ReactComponent };